import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { titleSplit } from 'src/app/utils/title-split';

@Component({
  selector: 'app-advisor-modal',
  templateUrl: './advisor-modal.component.html',
  styleUrls: ['./advisor-modal.component.scss']
})
export class AdvisorModalComponent implements OnInit {
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private ref: MatDialogRef<AdvisorModalComponent>) { }

  ngOnInit(): void {
  }


  gettitle(title: string | null, part = false): string {
    return titleSplit(title, part);
  }

  closeDialog() {
    this.ref.close();
  }

}
